<template>
    <q-dialog v-model="isShow">
        <q-card>
            <q-card-section>
                <div class="location-picker row col">
                    <!-- Search -->
                    <div class="row q-col-gutter-sm q-mb-sm">
                        <div class="col">
                            <!-- <q-input
                                v-model="searchText"
                                outlined
                                dense
                                label="Search location"
                                placeholder="e.g. Karachi, Pakistan"
                                @keyup.enter="searchLocation"
                            >
                                <template v-slot:append>
                                    <q-btn flat round dense icon="search" @click="searchLocation" />
                                </template>
                            </q-input> -->
                        </div>

                        <!-- Current Location -->
                        <div class="col-auto">
                            <q-btn
                                color="primary"
                                icon="my_location"
                                label="Current Location"
                                :loading="gettingLocation"
                                @click="getCurrentLocation"
                            />
                        </div>
                    </div>

                    <!-- Search results -->
                    <q-list v-if="searchResults.length" bordered separator class="search-results">
                        <q-item v-for="(item, index) in searchResults" :key="index" clickable @click="selectSearchResult(item)">
                            <q-item-section avatar>
                                <q-icon name="location_on" color="primary" />
                            </q-item-section>

                            <q-item-section>
                                <q-item-label>
                                    {{ item.display_name }}
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </q-list>

                    <!-- Map -->
                    <div class="map-container">
                        <l-map ref="map" :zoom="zoom" :center="mapCenter" @click="mapClicked">
                            <l-tile-layer :url="tileUrl" :attribution="attribution" />

                            <l-marker
                                v-if="location.lat && location.lng"
                                :lat-lng="[location.lat, location.lng]"
                                :draggable="true"
                                @dragend="markerDragged"
                            />
                        </l-map>
                    </div>

                    <!-- Coordinates -->
                    <div class="row q-col-gutter-sm q-mt-md">
                        <div class="col-6">
                            <!-- <q-input v-model.number="location.lat" outlined dense label="Latitude" readonly /> -->
                        </div>

                        <div class="col-6">
                            <!-- <q-input v-model.number="location.lng" outlined dense label="Longitude" readonly /> -->
                        </div>
                    </div>

                    <!--<div class="q-mt-sm">
                        <q-input v-model="location.address" outlined dense label="Address" readonly />
                    </div> -->

                    <!-- Select Button -->
                    <div class="row justify-end q-mt-md">
                        <q-btn
                            color="primary"
                            label="Select Location"
                            icon="check"
                            :disable="!location.lat || !location.lng"
                            @click="confirmLocation"
                        />
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';

import 'leaflet/dist/leaflet.css';

import L from 'leaflet';
import axios from 'axios';

// Fix Leaflet marker icon issue in webpack
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
    name: 'LocationPicker',

    components: {
        LMap,
        LTileLayer,
        LMarker,
    },

    props: {
        // Existing location
        value: {
            type: Object,
            default: null,
        },

        // Default location
        defaultLat: {
            type: Number,
            default: 24.8607,
        },

        defaultLng: {
            type: Number,
            default: 67.0011,
        },

        defaultZoom: {
            type: Number,
            default: 13,
        },
        isShowLocPick: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            zoom: this.defaultZoom,

            mapCenter: [this.defaultLat, this.defaultLng],

            location: {
                lat: null,
                lng: null,
                address: '',
            },

            searchText: '',

            searchResults: [],

            gettingLocation: false,

            tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',

            attribution: '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
            isShow: false,
        };
    },

    mounted() {
        // Existing location
        if (this.value && this.value.lat && this.value.lng) {
            this.location = {
                lat: Number(this.value.lat),
                lng: Number(this.value.lng),
                address: this.value.address || '',
            };

            this.mapCenter = [Number(this.value.lat), Number(this.value.lng)];
            this.isShow = this.isShowLocPick;
        }
        this.getCurrentLocation()
    },

    methods: {
        /*
         * Map Click
         */
        mapClicked(event) {
            const lat = event.latlng.lat;
            const lng = event.latlng.lng;

            this.setLocation(lat, lng);
        },

        showDialog() {
            this.isShow = true;
        },

        /*
         * Marker Drag
         */
        markerDragged(event) {
            const position = event.target.getLatLng();

            this.setLocation(position.lat, position.lng);
        },

        /*
         * Set Location
         */
        setLocation(lat, lng) {
            this.location.lat = Number(lat.toFixed(7));
            this.location.lng = Number(lng.toFixed(7));

            this.mapCenter = [this.location.lat, this.location.lng];

            // Address get karo
            this.reverseGeocode();
        },

        /*
         * Current Location
         */
        async getCurrentLocation() {
            if (!navigator.geolocation) {
                this.$q.notify({
                    type: 'negative',
                    message: 'Your browser does not support location services.',
                });
                return;
            }

            this.gettingLocation = true;

            // Pehle permission status check karo (agar browser support kare)
            if (navigator.permissions && navigator.permissions.query) {
                try {
                    const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });

                    if (permissionStatus.state === 'denied') {
                        this.gettingLocation = false;

                        // Denied state mein browser dobara prompt nahi karega,
                        // isliye user ko manually enable karne ko bolna padega
                        this.$q
                            .dialog({
                                title: 'Location Access Needed',
                                message:
                                    'Location permission blocked hai. Please apne browser settings se is site ke liye location allow karein, phir dobara try karein.',
                                ok: {
                                    label: 'OK',
                                    color: 'primary',
                                },
                            })
                            .onOk(() => {
                               
                                // Chahen to yahan browser settings ka link ya instructions bhi show kar sakte hain
                            });

                        return;
                    }
                } catch (e) {
                    // Kuch browsers 'geolocation' permission query support nahi karte,
                    // is case mein normally aage barh jao aur getCurrentPosition call karo
                }
            }

            // Agar denied nahi hai (ya query support nahi hai), to normal flow chalao
            // 'prompt' state mein ye khud browser ka native permission popup dikhayega
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;

                    this.setLocation(lat, lng);
                    this.zoom = 16;

                    this.$nextTick(() => {
                        if (this.$refs.map && this.$refs.map.mapObject) {
                            this.$refs.map.mapObject.setView([lat, lng], 16);
                        }
                    });

                    this.gettingLocation = false;
                },

                (error) => {
                    this.gettingLocation = false;

                    let message = 'Unable to get your current location.';

                    if (error.code === 1) {
                        message = 'Location permission was denied.';
                    }

                    if (error.code === 2) {
                        message = 'Location information is unavailable.';
                    }

                    if (error.code === 3) {
                        message = 'Location request timed out.';
                    }

                    this.$q.notify({
                        type: 'negative',
                        message,
                    });
                },

                {
                    enableHighAccuracy: true,
                    timeout: 15000,
                    maximumAge: 0,
                }
            );
        },
        // getCurrentLocation() {
        //     if (!navigator.geolocation) {
        //         this.$q.notify({
        //             type: 'negative',
        //             message: 'Your browser does not support location services.',
        //         });

        //         return;
        //     }

        //     this.gettingLocation = true;

        //     navigator.geolocation.getCurrentPosition(
        //         (position) => {
        //             const lat = position.coords.latitude;
        //             const lng = position.coords.longitude;

        //             this.setLocation(lat, lng);

        //             this.zoom = 16;

        //             this.$nextTick(() => {
        //                 if (this.$refs.map && this.$refs.map.mapObject) {
        //                     this.$refs.map.mapObject.setView([lat, lng], 16);
        //                 }
        //             });

        //             this.gettingLocation = false;
        //         },

        //         (error) => {
        //             this.gettingLocation = false;

        //             let message = 'Unable to get your current location.';

        //             if (error.code === 1) {
        //                 message = 'Location permission was denied.';
        //             }

        //             if (error.code === 2) {
        //                 message = 'Location information is unavailable.';
        //             }

        //             if (error.code === 3) {
        //                 message = 'Location request timed out.';
        //             }

        //             this.$q.notify({
        //                 type: 'negative',
        //                 message,
        //             });
        //         },

        //         {
        //             enableHighAccuracy: true,
        //             timeout: 15000,
        //             maximumAge: 0,
        //         }
        //     );
        // },

        /*
         * Search location
         *
         * OpenStreetMap Nominatim
         */
        async searchLocation() {
            if (!this.searchText.trim()) {
                return;
            }

            try {
                const url = 'https://nominatim.openstreetmap.org/search';

                const response = await this.$axios.get(url, {
                    params: {
                        q: this.searchText,
                        format: 'json',
                        limit: 5,
                        addressdetails: 1,
                    },

                    headers: {
                        Accept: 'application/json',
                    },
                });

                this.searchResults = response.data || [];
            } catch (error) {
                console.error('Location search error:', error);

                this.$q.notify({
                    type: 'negative',
                    message: 'Unable to search location.',
                });
            }
        },

        /*
         * Select search result
         */
        selectSearchResult(item) {
            const lat = Number(item.lat);
            const lng = Number(item.lon);

            this.location = {
                lat: Number(lat.toFixed(7)),
                lng: Number(lng.toFixed(7)),
                address: item.display_name || '',
            };

            this.mapCenter = [lat, lng];

            this.zoom = 16;

            this.searchText = item.display_name || '';

            this.searchResults = [];

            this.$nextTick(() => {
                if (this.$refs.map && this.$refs.map.mapObject) {
                    this.$refs.map.mapObject.setView([lat, lng], 16);
                }
            });

            this.emitLocation();
        },

        /*
         * Reverse Geocode
         *
         * Lat/Lng -> Address
         */
        async reverseGeocode() {
            if (!this.location.lat || !this.location.lng) {
                return;
            }

            try {
                const url = 'https://nominatim.openstreetmap.org/reverse';

                const response = await axios.get(url, {
                    params: {
                        lat: this.location.lat,
                        lon: this.location.lng,
                        format: 'json',
                        addressdetails: 1,
                        zoom: 18,
                    },
                    headers: {
                        Accept: 'application/json',
                    },
                });

                console.log('Reverse Geocode Response:', response.data);

                if (response.data) {
                    this.location.address = response.data.display_name || '';
                    

                    this.emitLocation();
                }
            } catch (error) {
                console.error('Reverse Geocode Error:', error.response || error);

                this.$q.notify({
                    type: 'negative',
                    message: 'Address could not be found.',
                });
            }
        },

        /*
         * Emit location to parent
         */
        emitLocation() {
            const data = {
                lat: this.location.lat,
                lng: this.location.lng,
                address: this.location.address,
            };
            
            console.log('data: ', data);
            this.$emit('input', data);

            this.$emit('selected', data);
        },

        /*
         * Confirm
         */
        confirmLocation() {
            const data = {
                lat: this.location.lat,
                lng: this.location.lng,
                address: this.location.address,
            };
            this.$emit('selected', data);
            this.isShow = false;
        },
    },
};
</script>

<style scoped>
.location-picker {
    width: 100%;
}

.map-container {
    width: 100%;
    height: 450px;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
}

.search-results {
    max-height: 250px;
    overflow-y: auto;
    margin-bottom: 10px;
}
</style>